import { QueryStringContextType } from '../../../context/querystring.context.ts';
import { TemplatesAttributeType } from './types.ts';

export const skipAttribute = (
  attributeConfig: TemplatesAttributeType['config'],
  market: string,
  pathname: string,
  region?: string,
  queryArgs?: QueryStringContextType,
): boolean => {
  // skip attribute if it doesn't alter slices based on templates (doesn't have a config/ not TemplatesAttributeType)
  if (!attributeConfig) {
    return true;
  }
  // skip attribute if it's not in the region
  if (region && attributeConfig.region && attributeConfig.region !== region) {
    return true;
  }
  // skip attribute if it's not in the targeted market
  if (
    attributeConfig.markets &&
    attributeConfig.markets.length &&
    !attributeConfig.markets.includes(market)
  ) {
    return true;
  }
  // skip attribute if it's not in the targeted pathname
  if (
    attributeConfig.targetedPathnames &&
    attributeConfig.targetedPathnames.strings &&
    attributeConfig.targetedPathnames.strings.length &&
    !attributeConfig.targetedPathnames.strings.includes(pathname)
  ) {
    return true;
  }
  // skip attribute if it's not in the targeted pathname regex
  if (
    attributeConfig.targetedPathnames &&
    attributeConfig.targetedPathnames.regex &&
    attributeConfig.targetedPathnames.regex.length &&
    !attributeConfig.targetedPathnames.regex.some((regex) =>
      new RegExp(regex).test(pathname),
    )
  ) {
    return true;
  }

  if (queryArgs && attributeConfig.filterByQueryArgs) {
    // Ensure every required query arg key matches one of the allowed values
    const filters = attributeConfig.filterByQueryArgs;
    for (const [key, allowedValues] of Object.entries(filters)) {
      const actual = queryArgs[key];
      // missing value or no matching allowed value -> skip attribute
      if (
        !actual ||
        !Array.isArray(allowedValues) ||
        !allowedValues.includes(actual)
      ) {
        return true;
      }
    }
  }

  return false;
};
